import apiV1, { getApiPrefix } from "@common/lib/api";
import { type I18n } from "@common/lib/i18n";
import { Users } from "./types";

const createApi = (i18n: I18n, isHost: boolean) => {
  const apiPrefix = getApiPrefix(isHost);

  return {
    getSingle: (id: number, cycleEndDate?: string): Promise<Users.Api.User> =>
      apiV1.get(i18n, `${apiPrefix}/user/users/${id}`, { cycleEndDate }),
    otp: {
      accounts: {
        getSteps: (id: string): Promise<Users.Api.OtpStep[]> =>
          apiV1.get(i18n, `${apiPrefix}/user/otp/accounts/${id}/steps`),
        getLinkSteps: (id: string): Promise<Users.Api.OtpStep[]> =>
          apiV1.get(i18n, `${apiPrefix}/user/otp/accounts/${id}/link/steps`),
        send: (id: string, messageType: Users.Api.OtpMessageType): Promise<Date> =>
          apiV1.post(i18n, `${apiPrefix}/user/otp/accounts/${id}/send`, { messageType })
      }
    }
  };
};

export const getApi = (i18n: I18n, isHost?: boolean) => createApi(i18n, isHost ?? false);
